import { render, staticRenderFns } from "./im-updata-info.vue?vue&type=template&id=6ad8b284"
import script from "./im-updata-info.vue?vue&type=script&lang=js"
export * from "./im-updata-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ad8b284')) {
      api.createRecord('6ad8b284', component.options)
    } else {
      api.reload('6ad8b284', component.options)
    }
    module.hot.accept("./im-updata-info.vue?vue&type=template&id=6ad8b284", function () {
      api.rerender('6ad8b284', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/im-layout/js/component/im-updata-info.vue"
export default component.exports